// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_JSDate from "../Data.JSDate/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Restaumatic_Currencies from "../Restaumatic.Currencies/index.js";
import * as Restaumatic_Money_HrkToEur from "../Restaumatic.Money.HrkToEur/index.js";
var isHrkEurEnabled = function __do() {
    var v = Effect_Now.nowDateTime();
    var activeFrom_m = Data_JSDate.toDateTime(Data_JSDate.jsdate({
        year: 2022.0,
        month: 8.0,
        day: 1.0,
        hour: 0.0,
        minute: 0.0,
        second: 0.0,
        millisecond: 0.0
    }));
    var result = Data_Maybe.fromMaybe(false)(Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(activeFrom_m)(function (activeFrom) {
        return Data_Ord.greaterThanOrEq(Data_DateTime.ordDateTime)(v)(activeFrom);
    }));
    return result;
};
var isEurHrkEnabled = function __do() {
    var v = Effect_Now.nowDateTime();
    var activeFrom_m = Data_JSDate.toDateTime(Data_JSDate.jsdate({
        year: 2023.0,
        month: 0.0,
        day: 1.0,
        hour: 0.0,
        minute: 0.0,
        second: 0.0,
        millisecond: 0.0
    }));
    var result = Data_Maybe.fromMaybe(false)(Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(activeFrom_m)(function (activeFrom) {
        return Data_Ord.greaterThanOrEq(Data_DateTime.ordDateTime)(v)(activeFrom);
    }));
    return result;
};
var hrkDualPricesEnabledRef = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(/* #__PURE__ */ Effect_Ref["new"](false));
var isHrkDualPricesEnabled = /* #__PURE__ */ Effect_Ref.read(hrkDualPricesEnabledRef);
var setHrkDualPricesEnabled = function (b) {
    return Effect_Ref.write(b)(hrkDualPricesEnabledRef);
};
var withHrkDualPricesEnabled = function (b) {
    return function (computation) {
        return Effect_Unsafe.unsafePerformEffect(function __do() {
            var previous = isHrkDualPricesEnabled();
            var u = setHrkDualPricesEnabled(b)();
            var result = computation(u);
            setHrkDualPricesEnabled(previous)();
            return result;
        });
    };
};
var currencyOptions = function (v) {
    if (v instanceof Restaumatic_Currencies.PLN) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "z\u0142"
        };
    };
    if (v instanceof Restaumatic_Currencies.CZK) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: "",
            unit: "K\u010d"
        };
    };
    if (v instanceof Restaumatic_Currencies.GBP) {
        return {
            format: "%u%n",
            precision: 2,
            separator: ".",
            delimiter: ",",
            unit: "\xa3"
        };
    };
    if (v instanceof Restaumatic_Currencies.USD) {
        return {
            format: "%u%n",
            precision: 2,
            separator: ".",
            delimiter: "",
            unit: "$"
        };
    };
    if (v instanceof Restaumatic_Currencies.EUR) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: "",
            unit: "EUR"
        };
    };
    if (v instanceof Restaumatic_Currencies.RUB) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "\u0440\u0443\u0431."
        };
    };
    if (v instanceof Restaumatic_Currencies.RON) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "RON"
        };
    };
    if (v instanceof Restaumatic_Currencies.HRK) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "kn"
        };
    };
    if (v instanceof Restaumatic_Currencies.BRL) {
        return {
            format: "%u%n",
            precision: 2,
            separator: ".",
            delimiter: "",
            unit: "R$"
        };
    };
    throw new Error("Failed pattern match at Restaumatic.I18n.Currency (line 61, column 3 - line 70, column 87): " + [ v.constructor.name ]);
};
var currencyUnit = function ($10) {
    return (function (v) {
        return v.unit;
    })(currencyOptions($10));
};
var formatCurrencySimple = function (currency) {
    return function (value) {
        return $foreign["_formatCurrency"](currencyOptions(currency), Data_Money_Rounded.toNumber(value));
    };
};
var formatCurrency = function (v) {
    return function (value) {
        if (v instanceof Restaumatic_Currencies.HRK && (Effect_Unsafe.unsafePerformEffect(isHrkDualPricesEnabled) && Effect_Unsafe.unsafePerformEffect(isHrkEurEnabled))) {
            return formatCurrencySimple(Restaumatic_Currencies.HRK.value)(value) + (" (" + (formatCurrencySimple(Restaumatic_Currencies.EUR.value)(Restaumatic_Money_HrkToEur.hrkToEur(value)) + ")"));
        };
        if (v instanceof Restaumatic_Currencies.EUR && (Effect_Unsafe.unsafePerformEffect(isHrkDualPricesEnabled) && Effect_Unsafe.unsafePerformEffect(isEurHrkEnabled))) {
            return formatCurrencySimple(Restaumatic_Currencies.EUR.value)(value) + (" (" + (formatCurrencySimple(Restaumatic_Currencies.HRK.value)(Restaumatic_Money_HrkToEur.eurToHrk(value)) + ")"));
        };
        return formatCurrencySimple(v)(value);
    };
};
export {
    formatCurrency,
    currencyUnit,
    isHrkDualPricesEnabled,
    setHrkDualPricesEnabled,
    withHrkDualPricesEnabled
};
//# sourceMappingURL=index.js.map
